import { useCallback } from 'react';
import { debounce } from 'throttle-debounce';

import { EBlockInPageName } from '../../../types/share';
import { trackChartSwipe } from '../../../tracking';

export function useOnSwipe(blockName: EBlockInPageName) {
  return useCallback(
    debounce(250, () => trackChartSwipe(blockName)),
    [],
  );
}
